<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <div class="crud-current-account-filters list-view-toolbar__filters mb-2">
          <div class="list-view-filter crud-current-account-filter-findobject" style="flex: 1 1 220px; max-width: 280px;">
            <FindObject render="search"
                    type="erpPointsSales"
                    display="full_identification"
                    @select-object="loadPointSales($event)"
                    :valueID="filters.points_sales_id"/>
          </div>
          <div class="list-view-filter" style="width: 150px;">
            <label class="filter-label">Desde</label>
            <b-form-input type="date" size="sm" v-model="filters.date_start"></b-form-input>
          </div>
          <div class="list-view-filter" style="width: 150px;">
            <label class="filter-label">Hasta</label>
            <b-form-input type="date" size="sm" v-model="filters.date_end"></b-form-input>
          </div>
          <b-button variant="outline-dark" size="sm" @click="filterReport()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
            <AppIcon name="filter" />
          </b-button>
        </div>

        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
          <b-tab @click="setTabActive('invoice')">
            <template #title><AppIcon name="receipt_long" class="mr-1" /> Por Factura</template>
            <b-table class="mb-0 app-table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :fields="tableInvoice.fields"
                    :items="formartedItemsInvoice"
                    @row-clicked="onRowClicked"
                    :tbody-tr-class="rowClass"
                    :busy="tableInvoice.isBusy"
                    v-if="tableInvoice.items.length || tableInvoice.isBusy">

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Cargando...</strong>
                </div>
              </template>

              <template v-slot:cell(date)="data">
                <div v-if="data.item.date">
                  {{ moment(data.item.date).format('DD MMMM YYYY') }}
                </div>
              </template>

              <template v-slot:cell(date_expiration)="data">
                <div v-if="data.item.date_expiration">
                  {{ moment(data.item.date_expiration).format('DD MMMM YYYY') }}
                </div>
              </template>

              <template v-slot:cell(description)="data">
                {{data.item.description}}
              </template>

              <template v-slot:cell(debit)="data">
                  <div v-if="data.item.debit" class="text-success">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.debit)}}
                  </div>
              </template>

              <template v-slot:cell(credit)="data">
                  <div v-if="data.item.credit" class="text-danger">
                    ({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.credit)}})
                  </div>
              </template>

              <template v-slot:cell(balance)="data">
                <div v-if="data.item.debit" class="text-success">
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.balance)}}
                </div>
                <div v-if="data.item.credit" class="text-danger">
                  ({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.balance)}})
                </div>
              </template>

              <template v-slot:cell(accumulated)="data">
                <b v-if="data.item.accumulated">
                  <b v-if="data.index==0">
                    <span :class="{'current-accounts-accumulate-positive-total':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative-total':parseFloat(data.item.accumulated)<0}">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                    </span>
                  </b>
                  <b v-else>
                    <span :class="{'current-accounts-accumulate-positive':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative':parseFloat(data.item.accumulated)<0}">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                    </span>
                  </b>
                </b>
              </template>

            </b-table>
            <EmptyState v-else icon="receipt_long" title="No se encontraron registros" />
          </b-tab>
          <b-tab @click="setTabActive('pending')">
            <template #title><AppIcon name="exclamation-triangle" class="mr-1" /> Pendiente</template>
            <b-table class="mb-0 app-table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :fields="tablePending.fields"
                    :items="formartedItemsPending"
                    :busy="tablePending.isBusy"
                    v-if="tablePending.items.length || tablePending.isBusy">

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:cell(date)="data">
                  <div v-if="data.item.date">
                    {{ moment(data.item.date).format('DD MMMM YYYY') }}
                  </div>
                </template>

                <template v-slot:cell(date_expiration)="data">
                  <div v-if="data.item.date_expiration">
                    {{ moment(data.item.date_expiration).format('DD MMMM YYYY') }}
                  </div>
                </template>

                <template v-slot:cell(description)="data">
                  {{data.item.description}}
                </template>

                <template v-slot:cell(debit)="data">
                    <div v-if="data.item.debit" class="text-success">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.debit)}}
                    </div>
                </template>

                <template v-slot:cell(credit)="data">
                    <div v-if="data.item.credit" class="text-danger">
                      ({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.credit)}})
                    </div>
                </template>

                <template v-slot:cell(accumulated)="data">
                  <b v-if="data.item.accumulated">
                    <b v-if="data.index==0">
                      <span :class="{'current-accounts-accumulate-positive-total':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative-total':parseFloat(data.item.accumulated)<0}">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                      </span>
                    </b>
                    <b v-else>
                      <span :class="{'current-accounts-accumulate-positive':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative':parseFloat(data.item.accumulated)<0}">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                      </span>
                    </b>
                  </b>
                </template>

            </b-table>
            <EmptyState v-else icon="exclamation-triangle" title="No se encontraron registros" />
          </b-tab>
          <b-tab @click="setTabActive('history')">
            <template #title><AppIcon name="history" class="mr-1" /> Histórica</template>
            <b-table class="mb-0 app-table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :fields="tableHistory.fields"
                    :items="formartedItemsHistory"
                    :busy="tableHistory.isBusy"
                    v-if="tableHistory.items.length || tableHistory.isBusy">

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Cargando...</strong>
                </div>
              </template>

              <template v-slot:cell(date)="data">
                <div v-if="data.item.date">
                  {{ moment(data.item.date).format('DD MMMM YYYY') }}
                </div>
              </template>

              <template v-slot:cell(date_expiration)="data">
                <div v-if="data.item.date_expiration">
                  {{ moment(data.item.date_expiration).format('DD MMMM YYYY') }}
                </div>
              </template>

              <template v-slot:cell(description)="data">
                {{data.item.description}}
              </template>

              <template v-slot:cell(debit)="data">
                  <div v-if="data.item.debit" class="text-success">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.debit)}}
                  </div>
              </template>

              <template v-slot:cell(credit)="data">
                  <div v-if="data.item.credit" class="text-danger">
                    ({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.credit)}})
                  </div>
              </template>

              <template v-slot:cell(accumulated)="data">
                  <b v-if="data.item.accumulated">
                    <b v-if="data.index==0">
                      <span :class="{'current-accounts-accumulate-positive-total':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative-total':parseFloat(data.item.accumulated)<0}">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                      </span>
                    </b>
                    <b v-else>
                      <span :class="{'current-accounts-accumulate-positive':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative':parseFloat(data.item.accumulated)<0}">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                      </span>
                    </b>
                  </b>
              </template>

            </b-table>
            <EmptyState v-else icon="history" title="No se encontraron registros" />
          </b-tab>
        </b-tabs>
      </b-card>

      <!-- DRAWER: comprobantes imputados a la factura seleccionada -->
      <b-sidebar
          id="sidebar-supplier-current-account-invoice"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle del Comprobante"
          width="380px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelectedPurchase">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code" v-if="itemSelectedPurchase.type_voucher && itemSelectedPurchase.point_sale">
                {{formatVoucherReference(itemSelectedPurchase)}}
              </span>
              <div class="list-view-drawer__meta" v-if="itemSelectedPurchase.date">
                {{moment(itemSelectedPurchase.date).format('DD/MM/YYYY')}}
              </div>
            </div>
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="link" /> Comprobantes Imputados
            </div>
            <b-table class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :items="tableDetailsPurchase.imputation.items"
                      :fields="tableDetailsPurchase.imputation.fields"
                      v-if="tableDetailsPurchase.imputation.items.length">

              <template v-slot:cell(date)="data">
                {{moment(data.item.date).format('DD/MM/YYYY')}}
              </template>

              <template v-slot:cell(reference)="data">
                {{data.item.reference}}
              </template>

              <template v-slot:cell(amount_total)="data">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency: itemSelectedPurchase.currency.code}).format(data.item.amount_total)}}
              </template>
            </b-table>
            <EmptyState v-else icon="link" title="No se encontraron comprobantes imputados" />
          </div>
        </div>
      </b-sidebar>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './../services'
  import Error from '@/handler/error'
  import moment from 'moment'
  import FindObject from '@/components/inc/find/findObject'   

  export default {
    props: [
      'suppliers',
      'suppliersID',
    ],    
    components: {
      FindObject,
    },     
    data: () => {
      return {              
        tableHistory : {
          items: [],
          filters: null,
          fields: [            
            {key: 'date', label: 'Fecha', class: "align-middle"},
            {key: 'description', label: 'Comprobante', class: "align-middle"},
            {key: 'date_expiration', label: 'Vencimiento', class: "align-middle"},            
            {key: 'debit', label: 'Debe', class: "align-middle text-right"},
            {key: 'credit', label: 'Haber', class: "align-middle text-right"},         
            {key: 'accumulated', label: 'Acumulado', class: "align-middle text-right"},
          ],                    
          isBusy: false,
        },
        tablePending : {
          items: [],
          filters: null,
          fields: [            
            {key: 'date', label: 'Fecha', class: "align-middle"},
            {key: 'description', label: 'Comprobante', class: "align-middle"},
            {key: 'date_expiration', label: 'Vencimiento', class: "align-middle"},            
            {key: 'debit', label: 'Debe', class: "align-middle text-right"},
            {key: 'credit', label: 'Haber', class: "align-middle text-right"},         
            {key: 'accumulated', label: 'Acumulado', class: "align-middle text-right"},
          ],                    
          isBusy: false,
        },  
        tableInvoice : {
          items: [],
          filters: null,
          fields: [            
            {key: 'date', label: 'Fecha', class: "align-middle"},
            {key: 'description', label: 'Comprobante', class: "align-middle"},
            {key: 'date_expiration', label: 'Vencimiento', class: "align-middle"},            
            {key: 'debit', label: 'Debe', class: "align-middle text-right"},
            {key: 'credit', label: 'Haber', class: "align-middle text-right"},         
            {key: 'balance', label: 'Saldo', class: "align-middle text-right"},         
            {key: 'accumulated', label: 'Acumulado', class: "align-middle text-right"},
          ],          
          isBusy: false,
        },                 
        tableDetailsPurchase: {       
          imputation : {
            items: [],
            fields: [
              {key: 'date', label: 'Fecha', class:"align-middle", width:"20%"},
              {key: 'reference', label: 'Referencia', class:"align-middle", width:"50%"},
              {key: 'amount_total', label: 'Total', class:"align-middle text-right", width:"30%"},
            ]
          },              
        },
        filters: {
          date_start: '',
          date_end: '',
          suppliers_id: 0,
          suppliers: null,
          points_sales: null,
          points_sales_id: 0,          
        },     
        tabSelect: 'invoice',
        itemSelectedPurchase: null,
        detailDrawer: false,
        isMobileViewport: false,
        arr: {
          invoice: [],
        }
      }
    },
    mounted() {
      this.filterLoad()
      this.filterReport()

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    computed: {
      // CONFIGURACION      
      getCurrency() {
        return 'ARS'
      }, 

      formartedItemsHistory () {
        if (!this.tableHistory.items) return []
        return this.tableHistory.items.map(item => {
          if(!item.print){
            item._rowVariant  = 'secondary'
          }
          
          return item
        })
      },
      formartedItemsPending () {
        if (!this.tablePending.items) return []
        return this.tablePending.items.map(item => {
          if(!item.print){
            item._rowVariant  = 'secondary'
          }
          
          return item
        })
      },
      formartedItemsInvoice () {
        if (!this.tableInvoice.items) return []
        return this.tableInvoice.items.map(item => {
          if(!item.print){
            item._rowVariant  = 'secondary'
          }
          
          return item
        })
      }     
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      formatPointSale(pointSale) {
        if(pointSale && typeof pointSale === 'object') {
          return pointSale.point_sale
        }
        return pointSale
      },
      formatVoucherReference(voucher) {
        var pointSale = this.formatPointSale(voucher.point_sale)
        return voucher.type_voucher.name + ' ' + pointSale.toString().padStart(4,'0') + '-' + voucher.number.toString().padStart(8,'0')
      },
      // Click en la fila abre el drawer con los comprobantes imputados,
      // salvo que el click haya sido sobre un control (el botón de imprimir).
      onRowClicked(item, index, event) {
        if(!item) return
        if(item.id<=0 || item.typeOperation!='purchase') return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
        }

        if(this.detailDrawer && this.tableInvoice.rowSelected === index) {
          this.hideSub()
        } else {
          this.tableInvoice.rowSelected = index
          this.detailDrawer = true
          this.loadDetailPurchase(item.regID)
        }
      },
      // Trae el detalle del comprobante seleccionado usando su regID directo
      // (evita depender de un refetch + reindexado de la tabla, que podía
      // desincronizarse y dejar el drawer abierto sin contenido).
      loadDetailPurchase(regID) {
        var result = serviceAPI.filtrarComprobanteById({id: regID})
        result.then((response) => {
          var data = response.data
          this.itemSelectedPurchase = data

          // IMPUTACIONES
          var arrImputations = []
          if(data.payments) {
            data.payments.forEach(element => {
              arrImputations.push({
                date: element.payment.date,
                reference: this.formatVoucherReference(element.payment),
                amount_total: element.amount_total
              })
            });
          }

          if(data.purchase_related) {
            data.purchase_related.forEach(element => {
              arrImputations.push({
                date: element.purchase_related.date,
                reference: this.formatVoucherReference(element.purchase_related),
                amount_total: element.amount_total
              })
            });
          }

          if(data.purchase_related_n_c) {
            data.purchase_related_n_c.forEach(element => {
              arrImputations.push({
                date: element.purchase.date,
                reference: this.formatVoucherReference(element.purchase),
                amount_total: element.amount_total
              })
            });
          }

          this.tableDetailsPurchase.imputation.items = arrImputations
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      // Resalta en la tabla la fila cuyo comprobante está abierto en el drawer.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.tableInvoice.rowSelected != null) {
          var selected = this.tableInvoice.items[this.tableInvoice.rowSelected]
          if(selected && item.id === selected.id) {
            return 'app-table-row-active'
          }
        }
        return ''
      },
      hideSub() {
        this.detailDrawer = false
        this.tableInvoice.rowSelected = null
        this.itemSelectedPurchase = null
        this.tableDetailsPurchase.imputation.items = []
      },
      filterLoad() {
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD') 
        this.filters.date_end = moment().format('YYYY-MM-DD') 
      },
      loadPointSales (object) {
        if(object){
          this.filters.points_sales = object
          this.filters.points_sales_id = object.id      

          this.filterReport()                
        } else {
          this.filters.points_sales = null
          this.filters.points_sales_id = 0   
          
          this.filterReport()                          
        }
      },  
      filterReport(){
        this.filters.suppliers_id = this.suppliersID

        if(!this.filters.suppliers_id) {
          this.$awn.alert("Debe seleccionar un proveedor");
          return false;
        }
        
        this.tablePending.isBusy = true
        this.tableHistory.isBusy = true
        this.tableInvoice.isBusy = true
        
        if(this.tabSelect=='history') {
          var resultHistory = serviceAPI.filtrarCurrentsAccounts(this.filters)        
          resultHistory.then((response) => {
            this.tablePending.items = []
            this.tableInvoice.items = []
            this.tableHistory.items = response.data  

            this.tablePending.isBusy = false
            this.tableHistory.isBusy = false
            this.tableInvoice.isBusy = false
          })
          .catch(error => {
            this.tablePending.isBusy = false
            this.tableHistory.isBusy = false
            this.tableInvoice.isBusy = false
            this.$awn.alert(Error.showError(error))
          })
        }
        if(this.tabSelect=='pending') {
          var resultPending = serviceAPI.filtrarCurrentsAccountsPending(this.filters)
          resultPending.then((response) => {
            this.tableHistory.items = []
            this.tableInvoice.items = []
            this.tablePending.items = response.data

            this.tablePending.isBusy = false
            this.tableHistory.isBusy = false
            this.tableInvoice.isBusy = false
          })
          .catch(error => {
            this.tablePending.isBusy = false
            this.tableHistory.isBusy = false
            this.tableInvoice.isBusy = false
            this.$awn.alert(Error.showError(error))
          })
        }
        if(this.tabSelect=='invoice') {          
          var resultInvoice = serviceAPI.filtrarCurrentsAccountsInvoice(this.filters)        
          resultInvoice.then((response) => {                                
            this.tableHistory.items = []
            this.tablePending.items = []
            this.tableInvoice.items = response.data
            
            this.arr.invoice  = response.data

            this.tablePending.isBusy = false
            this.tableHistory.isBusy = false
            this.tableInvoice.isBusy = false
          })
          .catch(error => {
            this.tablePending.isBusy = false
            this.tableHistory.isBusy = false
            this.tableInvoice.isBusy = false
            this.$awn.alert(Error.showError(error))
          })
        }
      },
      setTabActive(type) {        
        this.tabSelect = type
        if(this.filters.suppliers_id) {
          this.filterReport()                
        }
      },        
    }    
  }
</script>
<style>
  /* Este filtro no vive debajo de una cabecera con íconos (como en un
     list-view completo) — sin eso arriba, el borde superior heredado de
     .list-view-toolbar__filters queda flotando sin nada que dividir. */
  .crud-current-account-filters {
    margin-top: 0;
    padding-top: 0;
    border-top: none;
  }
  /* FindObject arma su <b-form-group :label="..."> SIN label-for — sin un
     id asociado, BootstrapVue renderiza el label como <legend> (fieldset),
     no <label>. Un <legend> trae su propio tamaño/peso default del
     navegador (grande y en negrita) que no tiene nada que ver con
     .filter-label — de ahí la fila desalineada si no se resetea. */
  .crud-current-account-filter-findobject .form-group {
    margin-bottom: 0;
  }
  .crud-current-account-filter-findobject legend,
  .crud-current-account-filter-findobject label {
    display: block;
    margin-bottom: 2px;
    padding: 0;
    border: none;
    float: none;
    width: auto;
    color: var(--app-color-text-secondary);
    font-size: 11px;
    font-weight: var(--app-font-semibold);
    line-height: normal;
  }
</style>
<style scoped>
  .current-accounts-accumulate-negative-total {
    font-size: 16px;
    color: #fff;
    background: var(--app-color-danger);
    padding: 3px;
  }
  .current-accounts-accumulate-positive-total {
    font-size: 16px;
    color: #fff;
    background: var(--app-color-success);
    padding: 3px;
  }
  .current-accounts-accumulate-negative {
    color: var(--app-color-danger);
  }
  .current-accounts-accumulate-positive {
    color: var(--app-color-success);
  }
</style>
